import { useAtom } from 'jotai';
import { Alert, Snackbar as MuiSnackbar } from '@mui/material';

import { snackbarPropsAtom } from '../../atoms';

const Snackbar = () => {
  const [snackbarProps, setSnackbarProps] = useAtom(snackbarPropsAtom);
  const { isOpen, message, type } = snackbarProps;

  return (
    <MuiSnackbar
      sx={{
        width: '100%',
        justifyContent: 'center',
      }}
      open={isOpen}
      autoHideDuration={5000}
      onClose={() => {
        setSnackbarProps({
          isOpen: false,
          message: message,
          type: type,
        });
      }}
    >
      <Alert severity={type}>{message}</Alert>
    </MuiSnackbar>
  );
};

export default Snackbar;
